import { useParams, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { SellOfferEdit } from '../components/offer/SellOfferEdit'
import { BuyOfferEdit } from '../components/offer/BuyOfferEdit'
import { getOffer } from '../services/offerService'
import { Button } from '../components/ui/button'
import { ArrowLeft, Loader2 } from 'lucide-react'

export function OfferEditPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [offerType, setOfferType] = useState<'Buy' | 'Sell' | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!id) {
      setIsLoading(false)
      return
    }
    getOffer(id)
      .then((offer) => setOfferType(offer.type as 'Buy' | 'Sell'))
      .catch(() => setOfferType(null))
      .finally(() => setIsLoading(false))
  }, [id])

  if (!id) {
    return (
      <div className="py-8">
        <p className="text-muted-foreground">Offer not found.</p>
        <Button variant="link" onClick={() => navigate('/offers')} className="mt-2 p-0">
          Back to offers
        </Button>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12 gap-2">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <span className="text-muted-foreground">Loading...</span>
      </div>
    )
  }

  if (!offerType) {
    return (
      <div className="py-8">
        <p className="text-muted-foreground">Offer not found.</p>
        <Button variant="link" onClick={() => navigate('/offers')} className="mt-2 p-0">
          Back to offers
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate('/offers')}
        className="text-gray-600 hover:text-gray-900 -ml-2"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to offers
      </Button>
      {offerType === 'Sell' ? (
        <SellOfferEdit offerId={id} />
      ) : (
        <BuyOfferEdit offerId={id} />
      )}
    </div>
  )
}
